import { takeEvery, select, put } from 'redux-saga/effects';
import { apiRequest } from './index';
import api from 'utils/api';
import { get } from 'lodash';
import * as licenseActions from 'actions/License';
import { Slide, toast } from 'react-toastify';
import history from '../utils/history';
import * as organizationActions from '../actions/Organizations';
import * as userActions from '../actions/User';
import { t } from 'i18n';

const getLicenseTemplates = apiRequest.bind(null, licenseActions.getLicenseTemplates, api.getLicenseTemplates);
const getLicenseTemplate = apiRequest.bind(null, licenseActions.getLicenseTemplate, api.getLicenseTemplate);
const createLicenseTemplate = apiRequest.bind(null, licenseActions.createLicenseTemplate, api.createLicenseTemplate);
const updateLicenseTemplate = apiRequest.bind(null, licenseActions.updateLicenseTemplate, api.updateLicenseTemplate);
const deleteLicenseTemplate = apiRequest.bind(null, licenseActions.deleteLicenseTemplate, api.deleteLicenseTemplate);
const assignLicense = apiRequest.bind(null, licenseActions.assignLicense, api.assignLicense);
const createLicense = apiRequest.bind(null, licenseActions.createLicense, api.createLicense);
const updateLicense = apiRequest.bind(null, licenseActions.updateLicense, api.updateLicense);
const getLicenses = apiRequest.bind(null, licenseActions.getLicenses, api.getLicenses);
const getSharedLicenses = apiRequest.bind(null, licenseActions.getSharedLicenses, api.getLicenses);
const getLicense = apiRequest.bind(null, licenseActions.getLicense, api.getLicense);
const assignPoolLicense = apiRequest.bind(null, licenseActions.assignPoolLicense, api.assignPoolLicense);

function* assignLicenseSuccess(action) {
  yield put({
    type: licenseActions.TOGGLE_CREATE_LICENSE_MODAL,
    payload: false,
  });
  yield put({
    type: licenseActions.TOGGLE_ASSIGN_LICENSE_MODAL,
    payload: false,
  });
  //remove all toast messages created by api-calls/page/... before displaying success message
  yield toast.dismiss();
  yield toast(t('messages.success'), {
    transition: Slide,
    closeButton: true,
    autoClose: 2000,
    position: 'bottom-center',
    type: 'success',
  });
  yield refreshLicenses(action);
}

function* assignPoolLicenseSuccess(action) {
  if (history.location.pathname.includes('licenses')) {
    const state = yield select();

    const arg = {
      data: {
        page: 0,
        licenseContains: get(state, 'License.tableFilter.search'),
      },
    };
    yield apiRequest.apply(null, [licenseActions.getLicenses, api.getLicenses, arg]);
    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.success'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
    return;
  }

  if (history.location.pathname.includes('user')) {
    const state = yield select();

    const arg = {
      id: state.User.id,
    };

    yield apiRequest.apply(null, [userActions.getUser, api.getUser, arg]);
    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.success'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
    return;
  }

  if (action.payload.options === 'redirect') {
    history.push('/licenses');
  } else {
    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.success'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });

    const arg = {
      id: action.payload.id,
    };

    yield apiRequest.apply(null, [licenseActions.getLicense, api.getLicense, arg]);
  }
}

function* refreshLicenses(action) {
  if (history.location.pathname.includes('organization')) {
    const arg = {
      id: action.payload.organizationId ? action.payload.organizationId : action.payload[0].organizationId,
    };

    yield apiRequest.apply(null, [organizationActions.getChildOrganization, api.getChildOrganization, arg]);

    return;
  }

  if (history.location.pathname.includes('user')) {
    const arg = {
      id: action.payload.userId ? action.payload.userId : action.payload[0].userId,
    };

    yield apiRequest.apply(null, [userActions.getUser, api.getUser, arg]);
    return;
  }

  //reload license-details after assigning
  if (history.location.pathname.includes('license-details')) {
    const arg = {
      id: action.payload?.id,
    };

    yield apiRequest.apply(null, [licenseActions.getLicense, api.getLicense, arg]);
    return;
  }

  const state = yield select();

  const arg = {
    data: {
      page: 0,
      licenseContains: get(state, 'License.tableFilter.search'),
    },
  };

  yield apiRequest.apply(null, [licenseActions.getLicenses, api.getLicenses, arg]);
}

function* deleteLicenseTemplateSuccess() {
  yield put({
    type: licenseActions.GET_LICENSE_TEMPLATES.REQUEST,
  });
}

function* createLicenseTemplateSuccess(action) {
  if (action.payload.options === 'redirect') {
    return yield history.push('/license-types');
  } else {
    yield history.push(`/edit-license-type/${action.payload.id}`);

    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.saved'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
  }
}

function* updateLicenseTemplateSuccess(action) {
  if (action.payload.options === 'redirect') {
    return yield history.push('/license-types');
  } else {
    const arg = { id: action.payload.id };

    yield apiRequest.apply(null, [licenseActions.getLicenseTemplate, api.getLicenseTemplate, arg]);

    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.saved'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
  }
}

/******************************************************************************/
/******************************* WATCHERS *************************************/

/******************************************************************************/

export function* watchGetLicenseTemplatesRequest() {
  yield takeEvery(licenseActions.GET_LICENSE_TEMPLATES.REQUEST, getLicenseTemplates);
}

export function* watchGetLicenseTemplateRequest() {
  yield takeEvery(licenseActions.GET_LICENSE_TEMPLATE.REQUEST, getLicenseTemplate);
}

export function* watchCreateLicenseTemplateRequest() {
  yield takeEvery(licenseActions.CREATE_LICENSE_TEMPLATE.REQUEST, createLicenseTemplate);
}

export function* watchCreateLicenseTemplateSuccess() {
  yield takeEvery(licenseActions.CREATE_LICENSE_TEMPLATE.SUCCESS, createLicenseTemplateSuccess);
}

export function* watchUpdateLicenseTemplateRequest() {
  yield takeEvery(licenseActions.UPDATE_LICENSE_TEMPLATE.REQUEST, updateLicenseTemplate);
}

export function* watchUpdateLicenseTemplateSuccess() {
  yield takeEvery(licenseActions.UPDATE_LICENSE_TEMPLATE.SUCCESS, updateLicenseTemplateSuccess);
}

export function* watchDeleteLicenseTemplateRequest() {
  yield takeEvery(licenseActions.DELETE_LICENSE_TEMPLATE.REQUEST, deleteLicenseTemplate);
}

export function* watchDeleteLicenseTemplateSuccess() {
  yield takeEvery(licenseActions.DELETE_LICENSE_TEMPLATE.SUCCESS, deleteLicenseTemplateSuccess);
}

export function* watchAssignLicenseRequest() {
  yield takeEvery(licenseActions.ASSIGN_LICENSE.REQUEST, assignLicense);
}

export function* watchAssignLicenseSuccess() {
  yield takeEvery(licenseActions.ASSIGN_LICENSE.SUCCESS, assignLicenseSuccess);
}

export function* watchCreateLicenseRequest() {
  yield takeEvery(licenseActions.CREATE_LICENSE.REQUEST, createLicense);
}

export function* watchCreateLicenseSuccess() {
  yield takeEvery(licenseActions.CREATE_LICENSE.SUCCESS, assignLicenseSuccess);
}

export function* watchUpdateLicenseRequest() {
  yield takeEvery(licenseActions.UPDATE_LICENSE.REQUEST, updateLicense);
}

export function* watchUpdateLicenseSuccess() {
  yield takeEvery(licenseActions.UPDATE_LICENSE.SUCCESS, assignPoolLicenseSuccess);
}

export function* watchGetLicensesRequest() {
  yield takeEvery(licenseActions.GET_LICENSES.REQUEST, getLicenses);
}

export function* watchGetSharedLicensesRequest() {
  yield takeEvery(licenseActions.GET_SHARED_LICENSES.REQUEST, getSharedLicenses);
}

export function* watchGetLicenseRequest() {
  yield takeEvery(licenseActions.GET_LICENSE.REQUEST, getLicense);
}

export function* watchAssignPoolLicenseRequest() {
  yield takeEvery(licenseActions.ASSIGN_POOL_LICENSE.REQUEST, assignPoolLicense);
}

export function* watchAssignPoolLicenseSuccess() {
  yield takeEvery(licenseActions.ASSIGN_POOL_LICENSE.SUCCESS, assignPoolLicenseSuccess);
}
